import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxInvoiceStatusFilter', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  function(enumCacheSvc, $filter, $rootScope) {
    return {
      restrict: 'E',
      require: '^ngModel',
      template: `<div class="dropdown" uib-dropdown is-open="ddwOpen" auto-close="outsideClick" on-toggle="toggleDropDown(open)">
                  <div class="input-group">
                    <input type="text" class="form-control" read-only ng-value="displayValue" ng-focus="ddwOpen=true" ng-click="ddwOpen=true; $event.stopPropagation(); $event.preventDefault();" autocomplete="off" placeholder="{{('Invoice State'|translate)}}" />
                    <div class="input-group-btn">
                      <button class="btn btn-default dropdown-toggle" ng-if="displayValue==''" uib-dropdown-toggle>
                        <span class="caret"></span>
                      </button>
                      <button class="btn btn-default" ng-if="displayValue!=''" ng-click="clearSelected()">
                        <span class="fa fa-times"></span>
                      </button>
                    </div>
                  </div>
                  <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="max-height:300px;overflow-y:auto">
                    <li ng-repeat="item in sendFilters track by item.key">
                      <a href ng-click="toggleItem(item)">
                        <i class="fa margin5R" ng-class="item.selected?'fa-check-square-o':'fa-square-o'"></i>
                        <span ng-show="item.key===0"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow inactive"></i><i class="state-flow inactive"></i></span>
                        <span ng-show="item.key===1"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow succeeded"></i><i class="state-flow inactive"></i><i class="state-flow inactive"></i></span>
                        <span ng-show="item.key===4"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow failed"></i><i class="state-flow inactive"></i><i class="state-flow inactive"></i></span>
                        <span ng-bind="item.label"></span>
                      </a>
                    </li>
                    <hr style="margin:0px"/>
                    <li ng-repeat="item in exportFilters track by item.key">
                    <a href ng-click="toggleItem(item)">
                      <i class="fa margin5R" ng-class="item.selected?'fa-check-square-o':'fa-square-o'"></i>
                      <span ng-show="item.key===0"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow grey"></i><i class="state-flow inactive"></i></span>
                      <span ng-show="item.key===4"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow progress"></i><i class="state-flow inactive"></i></span>
                      <span ng-show="item.key===1"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow succeeded"></i><i class="state-flow inactive"></i></span>
                      <span ng-show="item.key===3"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow failed"></i><i class="state-flow inactive"></i></span>
                      <span ng-bind="item.label"></span>
                    </a>
                  </li>
                  <hr style="margin:0px"/>
                    <li ng-repeat="item in peppolFilters track by item.key">
                    <a href ng-click="toggleItem(item)">
                      <i class="fa margin5R" ng-class="item.selected?'fa-check-square-o':'fa-square-o'"></i>
                      <span ng-show="item.key===0"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow grey"></i><i class="state-flow grey"></i></span>
                      <span ng-show="item.key===1"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow grey"></i><i class="state-flow progress"></i></span>
                      <span ng-show="item.key===2"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow grey"></i><i class="state-flow succeeded"></i></span>
                      <span ng-show="item.key===3"><i class="state-flow active"></i><i class="state-flow active"></i><i class="state-flow grey"></i><i class="state-flow grey"></i><i class="state-flow failed"></i></span>
                      <span ng-bind="item.label"></span>
                    </a>
                  </li>
                  </ul>
                </div>`,
      scope: {
        placeholder: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.initOnload = null;
        scope.displayValue = '';
        scope.ddwOpen = false;

        const invoiceFilters = [3, 1]; // processing, finalized
        const sendFilters = [0, 1, 4]; // not sent, sent, send failed
        const exportFilters = [0, 4, 1, 3]; // not exported,export started, exported, export failed,
        const peppolFilters = [0, 1, 2, 3]; // not exported,export started, exported succeeded, export failed,

        scope.invoiceFilters = invoiceFilters.map(x => ({
          key: x,
          label: $filter('translateList')(x, 'invoiceStatus', x),
          selected: false,
        }));
        scope.sendFilters = sendFilters.map(x => ({
          key: x,
          label: $filter('translateList')(x, 'emailStatus', x),
          selected: false,
        }));
        scope.exportFilters = exportFilters.map(x => ({
          key: x,
          label: $filter('translateList')(x, 'invoiceExportState', x),
          selected: false,
        }));
        scope.peppolFilters = peppolFilters.map(x => ({
          key: x,
          label: $filter('translateList')(x, 'invoicePeppolStatus', x),
          selected: false,
        }));
        scope.toggleItem = function(item) {
          item.selected = !item.selected;
          scope.setDisplayValue();
        };

        scope.setDisplayValue = function() {
          const selectedItems = scope.invoiceFilters
            .filter(x => x.selected)
            .concat(scope.sendFilters.filter(x => x.selected))
            .concat(scope.exportFilters.filter(x => x.selected))
            .concat(scope.peppolFilters.filter(x => x.selected));
          scope.displayValue = selectedItems.map(x => x.label).join(', ');
        };
        scope.clearSelected = function() {
          if (scope.invoiceFilters) {
            scope.invoiceFilters.forEach(x => {
              x.selected = false;
            });
          }
          if (scope.sendFilters) {
            scope.sendFilters.forEach(x => {
              x.selected = false;
            });
          }
          if (scope.exportFilters) {
            scope.exportFilters.forEach(x => {
              x.selected = false;
            });
          }
          if (scope.peppolFilters) {
            scope.peppolFilters.forEach(x => {
              x.selected = false;
            });
          }
          scope.displayValue = '';
          ngModel.$setViewValue({
            invoiceStatus: [],
            sendStatus: [],
            exportStatus: [],
            peppolExportStatus: [],
          });
          scope.ddwOpen = false;
        };

        scope.toggleDropDown = function(open) {
          if (!open) {
            const model = {
              invoiceStatus: scope.invoiceFilters.filter(x => x.selected).map(x => x.key),
              sendStatus: scope.sendFilters.filter(x => x.selected).map(x => x.key),
              exportStatus: scope.exportFilters.filter(x => x.selected).map(x => x.key),
              peppolExportStatus: scope.peppolFilters.filter(x => x.selected).map(x => x.key),
            };
            if (
              !angular.equals(
                model,
                ngModel.$viewValue || {
                  invoiceStatus: [],
                  sendStatus: [],
                  exportStatus: [],
                  peppolExportStatus: [],
                },
              )
            )
              ngModel.$setViewValue(model);
          }
        };

        ngModel.$render = function() {
          const model = ngModel.$viewValue || {
            invoiceStatus: [],
            sendStatus: [],
            exportStatus: [],
            peppolExportStatus: [],
          };
          let hasFilters = false;

          if (model.invoiceStatus && model.invoiceStatus.length) {
            hasFilters = true;
            scope.invoiceFilters.forEach(x => {
              x.selected = model.invoiceStatus && model.invoiceStatus.indexOf(x.key) >= 0;
            });
          }
          if (model.sendStatus && model.sendStatus.length) {
            hasFilters = true;
            scope.sendFilters.forEach(x => {
              x.selected = model.sendStatus && model.sendStatus.indexOf(x.key) >= 0;
            });
          }
          if (model.exportStatus && model.exportStatus.length) {
            hasFilters = true;
            scope.exportFilters.forEach(x => {
              x.selected = model.exportStatus && model.exportStatus.indexOf(x.key) >= 0;
            });
          }
          if (model.peppolExportStatus && model.peppolExportStatus.length) {
            hasFilters = true;
            scope.peppolFilters.forEach(x => {
              x.selected = model.peppolExportStatus && model.peppolExportStatus.indexOf(x.key) >= 0;
            });
          }
          if (hasFilters) {
            scope.setDisplayValue();
          } else {
            scope.clearSelected();
          }
        };
      },
    };
  },
]);
